export type OptionType = {
  value: number | string;
  label: string;
};

export const generateDayOptions = (): OptionType[] => {
  return Array.from({ length: 31 }, (_, i) => {
    const day = String(i + 1).padStart(2, "0");
    return { value: day, label: day };
  });
};

export const generateMonthOptions = (): OptionType[] => {
  return Array.from({ length: 12 }, (_, i) => {
    const month = String(i + 1).padStart(2, "0");
    return { value: month, label: month };
  });
};

export const generateYearOptions = (
  startYear = 1920,
  endYear = new Date().getFullYear()
): OptionType[] => {
  return Array.from({ length: endYear - startYear + 1 }, (_, i) => {
    const year = endYear - i;
    return { value: year, label: `${year}` };
  });
};

export const formatDDMMYYYY = (d: Date) => {
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
};

export const formatYYYYMMDD = (d: Date) => {
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${yyyy}/${mm}/${dd}`;
};

// lấy thứ 7 của tuần hiện tại (Sun=0 ... Sat=6)
export const getSaturdayOfThisWeek = (from = new Date()) => {
  const day = from.getDay(); // 0..6
  const diff = (6 - day + 7) % 7;
  const sat = new Date(from);
  sat.setDate(from.getDate() + diff);
  return sat;
};

export function timeStringToDate(time: string | undefined): Date | null {
  if (!time) return null;

  const [hourStr, minuteStr] = time.split(":");
  const hour = Number(hourStr);
  const minute = Number(minuteStr);

  const d = new Date();
  d.setHours(hour, minute, 0, 0);
  return d;
}
